module.exports = __webpack_public_path__ + "static/media/announcement.7a604219.svg";